// Home.js
import React from 'react';
import { Card, Col, Container, Row } from 'react-bootstrap';
import HomeCarousel from '../components/home-carousel/HomeCarousel';
import { ArrowRight, Facebook, Instagram } from 'react-bootstrap-icons';
import { Link } from 'react-router-dom';
import FBInit from '../components/facebook/FBInit';

function Home() {
  return (
    <>
      <HomeCarousel />
      <div className='mision home-block'>
        <Container>
          <h5>Familias en Misión Apostólica tiene como objetivo:</h5>
          <p>Promover los valores humano-cristianos de la familia en la comunidad, para que la familia sea formadora de personas, educadora en la fe, defensora de la vida, y, por tanto, comprometida activamente en el desarrollo integral de la comunidad a través de sus miembros.</p>
        </Container>
      </div>
      <Container className='representacion home-block pb-0'>
        <Row>
          <Col md={4}>
            <img src='/obispo-cepeda.png' />
            <div className='text'>
              <p className='title'>FAMA es representado ante la USCCB por Most Rev. Arturo Cepeda</p>
              <p>Auxiliary Bishop of San Antonio</p>
            </div>
          </Col>
          <Col md={4}>
            <img src='/frjacob.jpg' />
            <div className='text'>
              <p className='title'>El Padre Jacob VanAssche es el Asesor Espiritual Nacional de FAMA</p>
              <p>St. Damien of Molokai Parish, Pontiac MI</p>
            </div>
          </Col>
          <Col md={4}>
            <img src='/iccfm-logo-home.png' />
            <div className='text'>
              <p className='title'>FAMA está afiliado y reconocido por la ICCFM como un Movimiento Familiar Cristiano</p>
              <p>Que trabaja en beneficio de la familia y la vida</p>
            </div>
          </Col>
        </Row>
      </Container>
      <Container className='pilares home-block'>
        <h2 className='mt-4'>FAMA nos invita a:</h2>
        <Row>
          <Col md={4} className='mt-4'>
            <Card>
              <Card.Header>Vida de Equipo</Card.Header>
              <Card.Body>
                <ul>
                  <li>Asistir a todas las reuniones de estudio con nuestro Equipo Básico y a las tres reuniones generales de todos los niveles del Ciclo Básico de Formación.</li>
                  <li>Participar siempre con entusiasmo y ánimo de crecer junto con todo el equipo.</li>
                  <li>Fomentar en nuestro equipo un ambiente de diálogo, estudio, amistad, oración y compromiso en la acción.</li>
                </ul>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4} className='mt-4'>
            <Card>
              <Card.Header>Hospitalidad</Card.Header>
              <Card.Body>
                <ul>
                  <li>Recibir en nuestro hogar a los miembros de nuestro equipo con sencillez y cariño cuando nos corresponda.</li>
                  <li>Abrir nuestra mente y nuestro corazón para recibir a los miembros de nuestro equipo y ser tolerantes con las diversas formas de pensar de cada uno de ellos.</li>
                </ul>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4} className='mt-4'>
          <Card>
              <Card.Header>Estudio</Card.Header>
              <Card.Body>
                <ul>
                  <li>Estudiar previamente a las reuniones el tema correspondiente.</li>
                  <li>Realizar con empeño las reflexiones personales, conyugales, dinámica familiar y encuestas a otras personas que se encuentran en cada tema.</li>
                  <li>Participar con entusiasmo y respeto en las reuniones de estudio.</li>
                  <li>Llevar a cabo la Acción Sugerida que se acuerda al término de cada tema.</li>
                </ul>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col md={4} className='mt-4'>
            <Card>
              <Card.Header>Vida de oración</Card.Header>
              <Card.Body>
                <ul>
                  <li>Leer y reflexionar las citas bíblicas y los documentos del magisterio de la Iglesia que iluminan los temas.</li>
                  <li>Fomentar en nuestras familias la oración en común.</li>
                  <li>Vivir los momentos especiales: Kerigma, Encuentro conyugal y Encuentro familiar, correspondientes a los diversos niveles del Ciclo Básico de Formación.</li>
                </ul>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4} className='mt-4'>
            <Card>
              <Card.Header>Compromiso de servicio</Card.Header>
              <Card.Body>
                <ul>
                  <li>Cumplir responsablemente con los compromisos del equipo.</li>
                  <li>Participar con entusiasmo en alguno de los servicios que brinda FAMA.</li>
                  <li>Fomentar en nuestra familia el espíritu de servicio.</li>
                </ul>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4} className='mt-4'>
            <Card>
              <Card.Header>Uso cristiano de los bienes materiales</Card.Header>
              <Card.Body>
                <ul>
                  <li>Cumplir puntualmente con la aportación económica estipulada en la ficha de inscripción.</li>
                  <li>Fomentar en nuestra familia la solidaridad y el recto uso de los bienes materiales.</li>
                  <li>Crecer en conciencia y compromiso social.</li>
                </ul>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
      <div className='contactanos mt-4 home-block'>
        <Container>
          <Row>
            <Col xl={6}>
              <FBInit />
            </Col>
            <Col xl={6} className='pt-5'>
              <h2>Contáctanos para llevar este ministerio a tu parroquia</h2>
              <p><Link target='_blank' to="https://facebook.com/familiasenmisionapostolica"><Facebook size={48} />FamiliasEnMisionApostolica</Link></p>
              <p><Link target='_blank' to="https://instagram.com/familiasenmisionapostolica"><Instagram size={48} />FamiliasEnMisionApostolica</Link></p>
            </Col>
          </Row>
        </Container>
        <Row>

        </Row>
        
      </div>
    </>
  );
}

export default Home;
